import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { GamesGroupQuery, GamesGroupService, GroupType, IGroupSummary, LoyaltyFeed, LoyaltyFeedCardType } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-loyalty-feed-games',
  templateUrl: './loyalty-feed-games.component.html',
  styleUrl: './loyalty-feed-games.component.scss',
})
export class LoyaltyFeedGamesComponent {
  @Input() feed: LoyaltyFeed;
  @ViewChild('triviaContent', { static: true }) triviaContent: ElementRef;
  @ViewChild('predictorContent', { static: true }) predictorContent: ElementRef;
  gameGroup: IGroupSummary | null = null;
  groupTypes = GroupType;
  cardTypes = LoyaltyFeedCardType;
  private modalService = inject(NgbModal);
  private gamesGroupService = inject(GamesGroupService);
  public gamesGroupQuery = inject(GamesGroupQuery);

  openModal(id: number): void {
    this.gamesGroupService.fetchGroupById(id).subscribe((group) => {
      this.gameGroup = group;
      const isPredictor = this.feed.CardType === LoyaltyFeedCardType.Predictor;
      this.modalService.open(isPredictor ? this.predictorContent : this.triviaContent, {
        centered: true,
        backdrop: false,
        windowClass: isPredictor
          ? 'game-item-model-custom-style .modal-dialog game-predictor-model-background'
          : 'game-item-model-custom-style .modal-dialog game-trivia-model-background',
      });
    });
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }
}
